//src/pages/VisualBriefAddSlide.jsx 
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation  } from 'react-router-dom';
import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import validateManyFields from '../../validations';
import AILightComponent from '../../components/AILightComponent';
import AlertComponent from '../../components/AlertComponent';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';
import VBUploader from './VBUploader';

const VisualBriefAddSlide = () => {

  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const location = useLocation();
  const [vbMasterId, setVbMasterId] = useState("");
  const [vbMasterTitle, setVbMasterTitle] = useState("");
  const [noOfSlides, setNoOfSlides] = useState(0);

  useEffect(() => {
    // console.log("location: ",location);
    if (location.state) {
      setVbMasterId(location.state.vbMasterId || "");
      setVbMasterTitle(location.state.vbMasterTitle || "");
      setNoOfSlides(location.state.noOfSlides || 0);
    }
  }, [location.state]);

  // console.log("location.state: ",location.state);

  const [vbSlide, setSlide] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [hasImage, setHasImage] = useState(false);

  const generateCode = () => {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, "0");
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const year = now.getFullYear();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
  
    return `${day}${month}${year}${hours}${minutes}${seconds}`;
  };

  const [formData, setFormData] = useState({
    vbMasterId: vbMasterId,
    userId: userId,
    slideNumber: '',
    title: '',
    slideImageData: `${userCode}_vb_img_${generateCode()}`,
    slideDesc: '',
    hasAddlDesc: false,
    addlDesc: '',
    hasTTS: false,
    onScreenText: false,
    ttsText: '',
    ttsLang: '',
    ttsSpeed: 1,
    ttsPitch: 1,
    ttsVolume: 1,
    websites: '',
    youtubeURL: '',
    tedURL: '',
    vimeoURL: '',
    hasImage: false,
    think5whysVideoURL: `${userCode}_vb_vid_${generateCode()}`,
    othersVideoURL: '',
    isActive: true,
    isDeleted: false,
    createdBy: userId,
    dateCreated: new Date(),
    isLocked: true,
  });

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      vbMasterId: vbMasterId, 
    }));
  }, [vbMasterId]);

  const [formErrors, setFormErrors] = useState({});
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showAISupportAlert, setShowAISupportAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const { vbSlideId } = useParams();
  const mode = vbSlideId == null ? "add" : "update";

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: "/vbslides/getbyslideid", 
        method: "post", 
        data: {vbSlideId: vbSlideId},
        headers: { Authorization: authState.token } 
      };

      fetchData(config, { showSuccessToast: false }).then((data) => {
        setSlide(data);
        const mongoDate = new Date(data.vbslide.dateCreated);
        const jsDate = new Date(data.vbslide.dateCreated);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        setFormData({
          vbMasterId: data.vbslide.vbMasterId,
          userId: data.vbslide.userId,
          slideNumber: data.vbslide.slideNumber,
          title: data.vbslide.title,
          slideImageData: data.vbslide.slideImageData,
          slideDesc: data.vbslide.slideDesc,
          hasAddlDesc: data.vbslide.hasAddlDesc,
          addlDesc: data.vbslide.addlDesc,
          hasTTS: data.vbslide.hasTTS,
          onScreenText: data.vbslide.onScreenText,
          ttsText: data.vbslide.ttsText,
          ttsLang: data.vbslide.ttsLang,
          ttsSpeed: data.vbslide.ttsSpeed,
          ttsPitch: data.vbslide.ttsPitch,
          ttsVolume: data.vbslide.ttsVolume,
          hasImage: data.vbslide.hasImage,
          websites: data.vbslide.websites,
          youtubeURL: data.vbslide.youtubeURL,
          tedURL: data.vbslide.tedURL,
          vimeoURL: data.vbslide.vimeoURL,
          think5whysVideoURL: data.vbslide.think5whysVideoURL,
          othersVideoURL: data.vbslide.othersVideoURL,
          isActive: data.vbslide.isActive,
          isDeleted: data.vbslide.isDeleted,
          createdBy: data.vbslide.createdBy,
          dateCreated: data.vbslide.dateCreated,
          isLocked: data.vbslide.isLocked,
        });
      });
    }
  }, [mode, authState, vbSlideId, fetchData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // if (type === "checkbox") {
    //   const checkboxValue = checked ? 1 : 0;

    //   // if (name === "hasImage") {
    //   //   setHasImage(checked);
    //   // }

    //   setFormData({
    //     ...formData,
    //     [name]: checkboxValue
    //   });
    // } else if (name === "isActive") {
    //   const checkboxValue = checked ? 1 : 0;

    //   setIsActive(checked);

    //   setFormData({
    //     ...formData,
    //     [name]: checkboxValue
    //   });
    // } else {
      setFormData({
        ...formData,
        [name]: value
      });
    // }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateManyFields("slide", formData);

    setFormErrors({});

    if (errors.length > 0) {
      setFormErrors(errors.reduce((total, ob) => ({ ...total, [ob.field]: ob.err }), {}));
      return;
    }
    if (mode === "add") {
      const config = {
        url: "/vbslides",
        method: "post",
        data: formData,
        headers: { Authorization: authState.token }
      };
      
      fetchData(config)
        .then(() => {
          navigate('/vbslidelist', { state: { vbMasterId: vbMasterId, title: vbMasterTitle, noOfSlides: noOfSlides } });
        })
        .catch(error => {
          console.error("Error in saving data:", error);
        });
    }
    else {
      const config = {
        url: `/vbslides/${vbSlideId}`,
        method: "put",
        data: formData,
        headers: { Authorization: authState.token }
      };
      
      fetchData(config)
        .then(() => {
          navigate('/vbslidelist', { state: { vbMasterId: formData.vbMasterId, title: vbMasterTitle, noOfSlides: noOfSlides } });
        })
        .catch(error => {
          console.error("Error in updating the data:", error);
        });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.vbMasterId) {
      errors.vbMasterId = "Can't Find Presentation Master!";
    }
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.slideDesc) {
      errors.slideDesc = "Description is required";
    } else if (formData.slideDesc.length > 2000) {
      errors.slideDesc = "Description cannot exceed 2000 characters";
    }
    if (!formData.noOfSlides) {
      errors.noOfSlides = "Number of Slides is required";
    } else if (formData.noOfSlides < 3 || formData.noOfSlides > 25) {
      errors.noOfSlides = "Slides must be between 3 and 25";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleAISupportClick = () => {
    setShowAISupportAlert(true);
  };

  const handleCloseAlert = (alertType) => {
    if (alertType === 'microphone') {
      setShowMicrophoneAlert(false);
    } else if (alertType === 'aiSupport') {
      setShowAISupportAlert(false);
    }
  };

  return (
    <MainLayout>
      <div className="min-h-full py-4 px-4 bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 mt-12 rounded-lg">
        <h2 className='text-2xl font-bold text-white text-center mb-2'>VisualBrief - Slide Creation for {vbMasterTitle}</h2>
        {loading ? (
            <Loader />
        ) : (
          <div className='text-sm'>
            <div className='flex justify-center'>
              <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Slide" : "Edit Slide"}</h2>
            </div>
            <div className="border-container flex flex-col mt-4 mb-2 text-sm">
              <div className="mb-4">
                <label htmlFor="slideNumber">Slide# / {noOfSlides}:</label>
                <br />
                <input type="text" name="slideNumber" id="slideNumber" value={formData.slideNumber} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '10%' }} />
                {fieldError("slideNumber")}
              </div>
              <div className="mb-4">
                <label htmlFor="title">Title*:</label>
                <br />
                <input type="text" name="title" id="title" value={formData.title} placeholder="Enter the title..."
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '70%' }} />
                {fieldError("title")}
              </div>
              <div className="mb-4">
                <label htmlFor="slideDesc">Description*:</label>
                <textarea
                  type="slideDesc"
                  name="slideDesc"
                  id="slideDesc"
                  value={formData.slideDesc}
                  placeholder="Write Slide Description"
                  onChange={handleChange} className='text-black bg-slate-200 w-full'
                  style={{ border: '1px solid #ccc', padding: '2px', height: '200px', marginTop: '4px' }}
                />
                {fieldError("slideDesc")}
              </div>
              <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.hasImage}
                    onChange={handleChange}
                    name="hasImage"
                    className="mr-2"
                  />
                  Has Image?
                </label>
              </div>
              { formData.hasImage && mode==="update" && (
                <div>
                  <VBUploader param1="Slide Image" param2={formData.slideImageData} />
                </div>
              )}
              <div className="mb-4">
                <label htmlFor="slideImageData">Slide Image Id:</label>
                <br />
                <input
                  type="slideImageData"
                  name="slideImageData"
                  id="slideImageData"
                  value={formData.slideImageData}
                  placeholder="Image"
                  onChange={handleChange} className='text-black bg-slate-200 w-full'
                  style={{ border: '1px solid #ccc', width: "300px", padding: '2px', marginTop: '4px' }}
                  disabled={true}
                />
                {fieldError("slideImageData")}
              </div>
              {/* <div className="mb-4">
                <label htmlFor="slideDesc">Slide Description:</label>
                <br />
                <textarea
                  type="slideDesc"
                  name="slideDesc"
                  id="slideDesc"
                  value={formData.slideDesc}
                  placeholder="Write Description"
                  onChange={handleChange} className='text-black bg-slate-200 w-full'
                  style={{ border: '1px solid #ccc', padding: '2px', marginTop: '4px' }}
                />
                {fieldError("slideDesc")}
              </div> */}
              <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.hasAddlDesc}
                    onChange={handleChange}
                    name="hasAddlDesc"
                    className="mr-2"
                  />
                  Has Additional Description?
                </label>
              </div>
              <div className="mb-4">
                <label htmlFor="addlDesc">Additional Description:</label>
                <br />
                <textarea
                  type="addlDesc"
                  name="addlDesc"
                  id="addlDesc"
                  value={formData.addlDesc}
                  placeholder="Image"
                  onChange={handleChange} className='text-black bg-slate-200 w-full'
                  style={{ border: '1px solid #ccc', padding: '2px', height: '250px', marginTop: '4px' }}
                />
                {fieldError("addlDesc")}
              </div>
              <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.onScreenText}
                    onChange={handleChange}
                    name="onScreenText"
                    className="mr-2"
                  />
                  Play On Screen Description?
                </label>
              </div>
              <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.hasTTS}
                    onChange={handleChange}
                    name="hasTTS"
                    className="mr-2"
                  />
                  Has TTS?
                </label>
              </div>
              <div className="mb-4">
                <label htmlFor="ttsText">TTS Text:</label>
                <br />
                <textarea
                  type="ttsText"
                  name="ttsText"
                  id="ttsText"
                  value={formData.ttsText}
                  placeholder="Image"
                  onChange={handleChange} className='text-black bg-slate-200 w-full'
                  style={{ border: '1px solid #ccc', padding: '2px', height: '250px', marginTop: '4px' }}
                />
                {fieldError("ttsText")}
              </div>
              <div className="mb-4">
                <label htmlFor="ttsLang">TTS Language:</label>
                <br />
                <input type="text" name="ttsLang" id="ttsLang" value={formData.ttsLang} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} />
                {fieldError("ttsLang")}
              </div>
              <div className="mb-4">
                <label htmlFor="ttsSpeed">Speech Rate:</label>
                <br />
                <input type="number" min={0.5}  max={2.0} name="ttsSpeed" id="ttsSpeed" value={formData.ttsSpeed} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} />
                {fieldError("ttsSpeed")}
              </div>
              <div className="mb-4">
                <label htmlFor="ttsPitch">Speech Pitch:</label>
                <br />
                <input type="number" min={0.5}  max={2.0} name="ttsPitch" id="ttsPitch" value={formData.ttsPitch} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} />
                {fieldError("ttsPitch")}
              </div>
              <div className="mb-4">
                <label htmlFor="ttsVolume">Speech Volume:</label>
                <br />
                <input type="number" min={0.5}  max={2.0} name="ttsVolume" id="ttsVolume" value={formData.ttsVolume} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '50px' }} />
                {fieldError("ttsVolume")}
              </div>
              <div className="mb-4">
                <label htmlFor="websites">Website to Visit:</label>
                <br />
                <input type="text" name="websites" id="websites" value={formData.websites} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("websites")}
              </div>
              <div className="mb-4">
                <label htmlFor="youtubeURL">YouTube URL:</label>
                <br />
                <input type="text" name="youtubeURL" id="youtubeURL" value={formData.youtubeURL} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("youtubeURL")}
              </div>
              {/* <div className="mb-4">
                <label htmlFor="tedURL">TED URL:</label>
                <br />
                <input type="text" name="tedURL" id="tedURL" value={formData.tedURL} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("tedURL")}
              </div> */}
              {/* <div className="mb-4">
                <label htmlFor="vimeoURL">Vimeo URL:</label>
                <br />
                <input type="text" name="vimeoURL" id="vimeoURL" value={formData.vimeoURL} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("vimeoURL")}
              </div> */}
              <div className="mb-4">
                <label htmlFor="think5whysVideoURL">Think5Whys Cloud Video Id:</label>
                <br />
                <input type="text" name="think5whysVideoURL" id="think5whysVideoURL" value={formData.think5whysVideoURL} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("think5whysVideoURL")}
              </div>
              { formData.think5whysVideoURL !=="" && mode==="update" && (
                <div>
                  <VBUploader param1="Slide Video" param2={formData.think5whysVideoURL} />
                </div>
              )}
              {/* <div className="mb-4">
                <label htmlFor="othersVideoURL">Others Video URL:</label>
                <br />
                <input type="text" name="othersVideoURL" id="othersVideoURL" value={formData.othersVideoURL} 
                  onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                {fieldError("othersVideoURL")}
              </div> */}
              <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={handleChange}
                    name="isActive"
                    className="mr-2"
                  />
                  Is Active
                </label>
              </div>
              {/* <div className="mb-4">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.isLocked}
                    onChange={handleChange}
                    name="isLocked"
                    className="mr-2"
                  />
                  Is Locked for Delete
                </label>
              </div> */}
            </div>
            <div className="border-container flex flex-col justify-center">
              <div className="flex justify-center">
                {Object.keys(formErrors).length > 0 && (
                  <div className="form-errors text-red-300 justify-center items-center">
                    {Object.keys(formErrors).map((key) => (
                      <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-center">
                <button 
                  className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                  onClick={handleSubmit}>
                    {mode === "add" ? "Add New" : "Update"}
                </button>
                <button 
                  className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                  onClick={() => navigate("/vbslidelist", { state: { vbMasterId: formData.vbMasterId, title: vbMasterTitle, noOfSlides } })}
                >
                    Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );  
}

export default VisualBriefAddSlide